package com.essntl.features.area.ui.allareas

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.area.ui.allareas.components.AreaItem
import com.essntl.uikit.components.button.primary.EsSmallPrimaryButton
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun AllAreasScreen(
    state: AllAreasState,
    onEvent: (AllAreasEvent) -> Unit,
    onNavigation: (AllAreasNavigation) -> Unit,
) {
    Column(
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.Start,
        modifier = Modifier.fillMaxWidth(),
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier.fillMaxWidth(),
        ) {
            Text(
                text = "Areas",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.h4SemiBold20,
            )

            EsSmallPrimaryButton(
                text = "Add area",
                suffixIconRes = EsIcons.Add,
                onClick = {
                    onNavigation(AllAreasNavigation.AddArea)
                },
            )
        }

        Spacer(modifier = Modifier.height(2.spacing))

        if (state.getAllAreas.isLoading)
            EsSpinner()
        else if (state.getAllAreas.isFailure)
            Text(
                text = "Something goes wrong!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        else if (state.getAllAreas.data
                .orEmpty()
                .isEmpty()
        )
            Text(
                text = "No areas found!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        else
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(2.spacing),
                verticalArrangement = Arrangement.spacedBy(2.5.spacing),
                modifier = Modifier.fillMaxWidth(),
            ) {
                for (area in state.getAllAreas.data.orEmpty())
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(1.spacing),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        AreaItem(area = area)

                        EsSmallOutlineIconButton(
                            iconRes = EsIcons.Edit,
                            onClick = {
                                onNavigation(AllAreasNavigation.EditArea(area))
                            },
                        )
                    }
            }
    }
}